import { DrivingLocations } from "src/app/services/response-models/driving.response.model";

export class LoadDrivingLocations {
    static readonly type = "[Driving] Load driving locations";

    constructor(public payload: DrivingLocations) {}
}
